import React from 'react'

const Info = () => {
  return (
    <div>
              {/* <div className="mt-4"> */}
              <h1 className="head-font media-font fw-bolder display-4 mb-4">
                EU AI Act Compliance Checker
              </h1>
              <div className="fs-5 rounded">
                <p className="">
                  <strong>The EU AI Act</strong> imposes new regulatory
                  requirements on entities operating both within and outside the
                  EU. You can use our interactive tool to assess whether your AI
                  system may be subject to these obligations.
                </p>
                <p>
                  <em>
                    Please note that this assessment is preliminary and based on
                    our current interpretation of the EU AI Act. For a
                    comprehensive analysis, we strongly recommend consulting
                    professional legal counsel and referring to national
                    regulatory guidance.
                  </em>
                </p>
                <div
                  className="py-2 px-2 my-5 rounded"
                  style={{ border: "0.5px solid black" }}
                >
                  <p style={{ fontSize: "11px" }}>
                    <strong>P.S:</strong> Kindly share any feedback/changes
                    regarding this tool to Abhijeet at
                    <a
                      href="mailto:abhijeet.goel@testaing.com"
                      className="fw-bold text-decoration-none"
                      style={{ color: "black", fontSize: "10px" }}
                    >
                      {" "}
                      <span style={{ color: "#8b07fd" }}>
                        abhijeet.goel@testaing.com
                      </span>
                    </a>
                    .
                  </p>
                </div>
                {/* </div> */}
              </div>
            </div>
  )
}

export default Info